import React, { useEffect } from "react";
import withIntl from "../../utils/withIntl";
import { Fade, MenuItem, MenuList, Paper, Popper, TextField } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import cloudStore from "../../store/CloudStore";
import SelectedSalesAreas from "./SelectedSalesAreas";

const useStyles = makeStyles({
  menuList: { overflowY: "scroll", height: "80vh" },
  gridSalesArea: { height: "100%", display: "flex", flexWrap: "wrap" },
  section100: { width: "100%" },
});

function SearchSalesArea(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [searchValue, setSearchValue] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [taMerchants, setTaMerchants] = React.useState(null);
  const [spMerchants, setSpMerchants] = React.useState(null);

  if (cloudStore.merchants && taMerchants == null) {
    const taIds = [];
    const spIds = [];
    cloudStore.merchants.map((merchant) => {
      if (merchant.ta_merchants != null) {
        merchant.ta_merchants.forEach((taMerchant) => taIds.push(taMerchant));
      }
      if (merchant.sp_merchants != null) {
        merchant.sp_merchants.forEach((spMerchant) => spIds.push(spMerchant));
      }
    });
    setSpMerchants(spIds);
    setTaMerchants(taIds);
  }

  let loading = anchorEl && options.length === 0;

  let allSearchResults = taMerchants?.reduce((taMerchants, taMerchant) => {
    let merchant = taMerchant;
    merchant.renderedName = `${merchant.merchant.name} "Takeaway & Delivery"`;
    merchant.type = "taMerchant";
    taMerchants.push(merchant);
    return taMerchants;
  }, []);

  allSearchResults = allSearchResults?.concat(
    spMerchants.reduce((spMerchants, spMerchant) => {
      let merchant = spMerchant;
      merchant.renderedName = `${merchant.merchant.name} "Inhouse"`;
      merchant.type = "spMerchant";
      spMerchants.push(merchant);
      return spMerchants;
    }, [])
  );

  if (allSearchResults) {
    allSearchResults.sort(function (a, b) {
      const nameA = a.renderedName.toUpperCase();
      const nameB = b.renderedName.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
  }

  const search = (searchValue) => {
    if (!cloudStore.merchant) {
      return [];
    }

    let searchResults = allSearchResults.reduce((merchants, merchant) => {
      if (merchants.length > 19) {
        return merchants;
      }
      let searchValues = searchValue.split(/\s/);

      if (
        searchValues.every((value) => {
          if (value.length === 0) {
            return true;
          }
          if (merchant.renderedName.toLowerCase().includes(value.toLowerCase())) {
            return true;
          }
          return false;
        })
      ) {
        if (!selectedItems.map((item) => item.id).includes(merchant.id)) {
          merchants.push(merchant);
        }
      }
      return merchants;
    }, []);

    return searchResults;
  };

  const addOptionToSelectedItems = (options) => {
    let oldValues = [...selectedItems];
    oldValues = oldValues.concat(options);
    setSelectedItems(oldValues);
  };

  useEffect(() => {
    let active = true;

    (async () => {
      const merchants = await search(searchValue);
      merchants.push({ renderedName: "Select all", id: 0 });
      if (active) {
        setOptions(merchants);
      }
    })();

    return () => {
      active = false;
    };
  }, [searchValue, selectedItems]);

  useEffect(() => {
    props.handleSetMerchantIds(selectedItems);
  }, [selectedItems]);

  useEffect(() => {
    const standardSelectedItems = allSearchResults.filter((result) => result.merchant_id === cloudStore.merchant.id);

    setSelectedItems(standardSelectedItems);
  }, []);

  const handleRemoveFromItems = (itemName) => {
    const oldSelectedItems = [...selectedItems];
    const index = oldSelectedItems.findIndex((item) => item.renderedName === itemName);
    oldSelectedItems.splice(index, 1);
    setSelectedItems(oldSelectedItems);
  };

  return (
    <div style={{ height: 350 }}>
      <Paper>
        <div className={{ root: classes.gridSalesArea }}>
          <div className={classes.section100}>
            <div style={{ padding: "0 15px" }}>
              <TextField
                fullWidth
                // variant={"outlined"}
                onFocus={(event) => {
                  setAnchorEl(anchorEl ? null : event.currentTarget);
                }}
                onBlur={(event) => {
                  setAnchorEl(anchorEl ? null : event.currentTarget);
                }}
                label={props.intl.formatMessage({ id: "select_sales_areas" })}
                value={searchValue}
                onChange={(event) => setSearchValue(event.target.value)}
              />
            </div>
            <Popper
              placement={"bottom-start"}
              id={"popper-search-sales-area"}
              anchorEl={anchorEl}
              open={anchorEl != null}
              transition
            >
              {({ TransitionProps }) => (
                <Fade {...TransitionProps} timeout={350}>
                  <Paper>
                    <MenuList key={options.length} classes={{ root: classes.menuList }}>
                      {options.map((option, index) => (
                        <MenuItem
                          key={option.renderedName + index}
                          value={index}
                          onClick={() => {
                            if (option.id === 0) {
                              let index = options.map((option) => option.id).indexOf(0);
                              options.splice(index, 1);
                              addOptionToSelectedItems(options);
                            } else {
                              addOptionToSelectedItems(option);
                            }
                            setSearchValue(searchValue);
                          }}
                        >
                          {option.renderedName}
                        </MenuItem>
                      ))}
                    </MenuList>
                  </Paper>
                </Fade>
              )}
            </Popper>
          </div>
          <div className={classes.section100}>
            <SelectedSalesAreas
              handleReportData={props.handleReportData}
              setSelectedItems={setSelectedItems}
              key={selectedItems.length}
              selectedItems={selectedItems}
              handleRemoveFromItems={handleRemoveFromItems}
            />
          </div>
        </div>
      </Paper>
    </div>
  );
}

export default withIntl(SearchSalesArea);
